import { render, staticRenderFns } from "./CreateTask.vue?vue&type=template&id=48294878&scoped=true&"
import script from "./CreateTask.vue?vue&type=script&lang=js&"
export * from "./CreateTask.vue?vue&type=script&lang=js&"
import style0 from "./CreateTask.vue?vue&type=style&index=0&id=48294878&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48294878",
  null
  
)

export default component.exports